<script>
import SelectDropdown from "../SelectDropdown.vue";
import InfoCard from "../InfoCard.vue";
import StyleBox from "../StyleBox.vue";
//import store from "@/store";
import InputField from "../InputField.vue";
import ColorSchemeBox from "../ColorSchemeBox.vue";
import OrgChartTemp1 from "../templates/orgChart/OrgChartTemp1.vue";
import OrgChartTemp2 from "../templates/orgChart/OrgChartTemp2.vue";
import ProjectsDropdown from "../ProjectsDropdown.vue";
import OrgChartTemp3 from "../templates/orgChart/OrgChartTemp3.vue";
import OrgChartTemp4 from "../templates/orgChart/OrgChartTemp4.vue";
import OrgChartTemp5 from "../templates/orgChart/OrgChartTemp5.vue";
import OrgChartTemp6 from "../templates/orgChart/OrgChartTemp6.vue";
import OrgChartTemp7 from "../templates/orgChart/OrgChartTemp7.vue";
import PreviewTemplates from "../PreviewTemplates.vue";
import AppButton from "../AppButton.vue";
import { isOrgChartReady } from "@/utils/proposalValidation";
import img1 from "@/assets/images/templates/OrgChartTemp1.png";
import img2 from "@/assets/images/templates/OrgChartTemp2.png";
import img3 from "@/assets/images/templates/OrgChartTemp3.png";
import img4 from "@/assets/images/templates/OrgChartTemp4.png";
import img5 from "@/assets/images/templates/OrgChartTemp5.png";
import img6 from "@/assets/images/templates/OrgChartTemp6.png";
import img7 from "@/assets/images/templates/OrgChartTemp7.png";

export default {
    name: "StepOrgChart",
    components: {
        SelectDropdown,
        InfoCard,
        StyleBox,
        InputField,
        ColorSchemeBox,
        OrgChartTemp1,
        OrgChartTemp2,
        ProjectsDropdown,
        OrgChartTemp3,
        OrgChartTemp4,
        OrgChartTemp5,
        OrgChartTemp6,
        OrgChartTemp7,
        PreviewTemplates,
        AppButton,
    },
    props: {
        proposal: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            memberSearchQuery: "",
            prompt: "",
            isGeneratingMembers: false,
            memberErrorMessage: "",
            TemplateList: [
                {
                    label: '1- Display square shaped nodes for members',
                    value: 1,
                    preview: img1,
                    orientation: "portrait",
                    style: this.getTemplateStyle(1)
                },
                {
                    label: '2- Display circular shaped nodes for members',
                    value: 2,
                    preview: img2,
                    orientation: "portrait",
                    style: this.getTemplateStyle(2)
                },
                {
                    label: '3- Display circular shaped nodes for members and about section with one project',
                    value: 3,
                    preview: img3,
                    orientation: "portrait",
                    style: this.getTemplateStyle(3)
                },
                {
                    label: '4- Display portrait layout with Rectangular shaped nodes for members with about section',
                    value: 4,
                    preview: img4,
                    orientation: "portrait",
                    style: this.getTemplateStyle(4)
                },
                {
                    label: '1- Display landscape layout with Rectangular shaped nodes for members with about section',
                    value: 5,
                    preview: img5,
                    orientation: "landscape",
                    style: this.getTemplateStyle(5)
                },
                {
                    label: '2- Display landscape layout with 2x2 grid for members with circular photos and AI bios',
                    value: 6,
                    preview: img6,
                    orientation: "landscape",
                    style: this.getTemplateStyle(6)
                },
                {
                    label: '3- Display landscape layout with 2x2 grid, square photos and full background image',
                    value: 7,
                    preview: img7,
                    orientation: "landscape",
                    style: this.getTemplateStyle(7)
                }
            ],
            debouncedMemberSearch: null,
            //store
        };
    },
    computed: {
        members() {
            return (this.$store.state.members && this.$store.state.members.data) || [];
        },
        membersPagination() {
            return (this.$store.state.members && this.$store.state.members.pagination) || {};
        },
        MembersLoading() {
            return this.$store.state.loading.member;
        },
        membersOptions() {
            return this.members
                .map((item) => ({ label: item.teamMemberName, value: item.teamMemberId }))
                .filter(Boolean);
        },
        canPaginateMembers() {
            return ((this.membersPagination && this.membersPagination.page) || 0) < ((this.membersPagination && this.membersPagination.totalPages) || 0);
        },
        pioneerId() {
            return this.proposal.orgChart.members[0] ? this.proposal.orgChart.members[0].teamMemberId : null;
        },
        isPreviewable() {
            return isOrgChartReady(this.proposal.orgChart);
        },
        previewText() {
            const orgChart = this.proposal.orgChart;
            if (!orgChart.template) return "Select template to preview";
            if (orgChart.members.length === 0) return "Select Atleast one member to preview";
            if (orgChart.template === 3 || orgChart.template === 4 || orgChart.template === 5) {
                if (!orgChart.about.title) return "Fill the about section to preview";
                if (!orgChart.about.description) return "Fill the about section to preview";
            }
            if (orgChart.template === 6 || orgChart.template === 7) {
                if (orgChart.members.some(m => !m.whyTeamMember || m.whyTeamMember.trim() === "")) return "Generate bio response for each team member to preview";
            }
            return "";
        }
    },
    watch: {
        memberSearchQuery() {
            if (!this.debouncedMemberSearch) {
                this.debouncedMemberSearch = this.debounce(() => {
                    this.fetchMembersList(1);
                }, 500);
            }
            this.debouncedMemberSearch();
        }
    },
    methods: {
        debounce(fn, delay) {
            let timeoutId;
            return (...args) => {
                if (timeoutId) clearTimeout(timeoutId);
                timeoutId = setTimeout(() => {
                    fn(...args);
                }, delay);
            };
        },
        async fetchMembersList(page = 1) {
            await this.$store.dispatch("fetchMembers", {
                page,
                search: this.memberSearchQuery,
            });
        },
        handleMembersPagination() {
            this.fetchMembersList(((this.membersPagination && this.membersPagination.page) || 0) + 1);
        },
        removeTeamMember(id) {
            const updatedMembers = this.proposal.orgChart.members.filter(
                (m) => m.teamMemberId !== id
            );
            this.proposal.orgChart.members = updatedMembers;
        },
        moveItem({ from, to }) {
            const membersList = [...this.proposal.orgChart.members];
            if (from < 0 || to < 0 || from >= membersList.length || to >= membersList.length)
                return;

            const [movedItem] = membersList.splice(from, 1);
            membersList.splice(to, 0, movedItem);
            this.proposal.orgChart.members = membersList;
        },
        handleProjectSelection(selectedIds) {
            this.proposal.orgChart.projects = selectedIds;
        },
        getTemplateStyle(t) {
            return {
                colorScheme: {
                    header: t == 4 ? "#181c45" : t == 5 ? "#ffffff" : t == 6 || t == 7 ? "#000000" : "#545454",
                    body: t == 6 || t == 7 ? "#4075b9" : t == 2 || t == 3 || t == 4 || t == 5 ? "#ffffff" : "#e3e3e4",
                    footer: t == 4 ? "#181c45" : t == 5 ? "#000000" : t == 6 || t == 7 ? "#000000" : "#545454",
                },
                heading: {
                    color: t == 3 || t == 6 || t == 7 ? "#ffffff" : "#002b61",
                    size: t == 5 ? "18" : t == 6 || t == 7 ? "14" : "22",
                    font: "Arial",
                    bold: true,
                    italic: false,
                    underline: false,
                },
                label: {
                    color: t == 4 || t == 5 ? "#002b61" : t == 6 || t == 7 ? "#ffffff" : "#004aac",
                    size: t == 6 || t == 7 ? "14" : "12",
                    font: "Arial",
                    bold: t == 4 || t == 5 ? false : true,
                    italic: false,
                    underline: false,
                },
                text: {
                    color: t == 6 || t == 7 ? "#ffffff" : t == 4 || t == 5 ? "#000000" : "#004aac",
                    size: t == 4 || t == 5 || t == 6 ? "14" : "12",
                    font: "Arial",
                    bold: false,
                    italic: false,
                    underline: false,
                },
            };
        },
        fixStyling() {
            const match = this.TemplateList.find(item => item.value === this.proposal.orgChart.template);
            if (match) this.proposal.orgChart.style = match.style;
        },
        normalizeMembersForTemplate(membersList, template) {
            const isFlatTemplate = template === 6 || template === 7;
            const safeMembers = Array.isArray(membersList) ? membersList.filter(Boolean) : [];

            if (isFlatTemplate) {
                return safeMembers.map((member) => ({
                    ...member,
                    reportsToId: null,
                }));
            }

            return safeMembers.map((member, index) => ({
                ...member,
                reportsToId: index === 0 ? null : (member.reportsToId ?? null),
            }));
        },
        handleTemplateSelection(template) {
            const oldTemplate = this.proposal.orgChart.template;
            const isOldFlat = oldTemplate === 6 || oldTemplate === 7;
            const isNewFlat = template === 6 || template === 7;

            if (isOldFlat !== isNewFlat) {
                this.proposal.orgChart.members = [];
            } else {
                this.proposal.orgChart.members = this.normalizeMembersForTemplate(
                    this.proposal.orgChart.members,
                    template
                );
            }

            this.proposal.orgChart.template = template;
            if (template !== 3 && template !== 7) {
                this.proposal.orgChart.projects = [];
            }
            this.fixStyling();
        },
        async summarizeMember(member) {
            const t = this.proposal.orgChart.template;
            if (t !== 6 && t !== 7) return;

            const id = member.teamMemberId;
            const type = "member";

            if (member.whyTeamMember && member.whyTeamMember.trim() !== "") return;

            const cached = this.$store.state.aiResponses[`${type}-${id}`];
            if (cached) {
                member.whyTeamMember = cached;
                return;
            }

            const promptText = `Write a concise introduction highlighting his role in organization. The candidate’s name is ${member.teamMemberName} and his role is ${member.role}. In 1–2 professional sentences (maximum 450 characters), explain his primary responsibilities, Maintain a factual, objective tone similar to a job description or professional summary. Avoid marketing language, buzzwords, first-person phrasing, headings, or exaggerated claims.`;

            try {
                const response = await this.$store.dispatch("generateAIResponseById", { type, id, prompt: promptText });
                if (response) {
                    member.whyTeamMember = response;
                }
            } catch (error) {
                console.error("AI Generation failed for member:", id, error);
            }
        },
        handlePioneerSelection(id) {
            const member = this.members.find(m => m.teamMemberId === id);
            if (!member) return;

            const existingMember = this.proposal.orgChart.members.find(
                (m) => m.teamMemberId === id
            );

            const newMember = {
                ...(existingMember || member),
                reportsToId: null
            };

            this.proposal.orgChart.members = [newMember];

            const t = this.proposal.orgChart.template;
            if (t === 6 || t === 7) {
                this.summarizeMember(newMember);
            }
        },
        getSubordinates(managerId) {
            return this.proposal.orgChart.members
                .filter(m => m.reportsToId === managerId)
                .map(m => m.teamMemberId);
        },
        getAvailableSubordinates(managerId) {
            const currentChartIds = this.proposal.orgChart.members.map(m => m.teamMemberId);
            const assignedToMeIds = this.getSubordinates(managerId);

            return this.members
                .filter(m => !currentChartIds.includes(m.teamMemberId) || assignedToMeIds.includes(m.teamMemberId))
                .map(m => ({ label: m.teamMemberName, value: m.teamMemberId }));
        },
        handleSubordinateSelection(selectedSubIds, managerId) {
            let currentChartMembers = [...this.proposal.orgChart.members];
            const existingSubIds = this.getSubordinates(managerId);

            selectedSubIds.forEach(id => {
                if (!existingSubIds.includes(id)) {
                    const existingMember = currentChartMembers.find((m) => m.teamMemberId === id);
                    const memberData = this.members.find(m => m.teamMemberId === id);
                    if (memberData || existingMember) {
                        const newSub = {
                            ...(existingMember || memberData),
                            reportsToId: managerId
                        };
                        currentChartMembers.push(newSub);

                        const t = this.proposal.orgChart.template;
                        if (t === 6 || t === 7) {
                            this.summarizeMember(newSub);
                        }
                    }
                }
            });

            const idsToRemove = existingSubIds.filter(id => !selectedSubIds.includes(id));

            const removeRecursive = (list, ids) => {
                let newList = list.filter(m => !ids.includes(m.teamMemberId));
                const descendants = list.filter(m => ids.includes(m.reportsToId)).map(m => m.teamMemberId);
                if (descendants.length > 0) {
                    return removeRecursive(newList, descendants);
                }
                return newList;
            };

            if (idsToRemove.length > 0) {
                currentChartMembers = removeRecursive(currentChartMembers, idsToRemove);
            }

            this.proposal.orgChart.members = currentChartMembers;
        },
        handleSimpleMembersSelection(selectedIds) {
            const oldIds = new Set((this.proposal.orgChart.members || []).map(m => m.teamMemberId));
            const existing = this.proposal.orgChart.members;

            const updatedMembers = selectedIds.map(id => {
                const found = existing.find(m => m.teamMemberId === id);
                if (found) return found;

                const memberData = this.members.find(m => m.teamMemberId === id);
                if (!memberData) return null;

                const newMember = { ...memberData, reportsToId: null };
                return newMember;
            }).filter(Boolean);

            this.proposal.orgChart.members = updatedMembers;

            const t = this.proposal.orgChart.template;
            if (t === 6 || t === 7) {
                updatedMembers.forEach(m => {
                    if (!oldIds.has(m.teamMemberId)) {
                        this.summarizeMember(m);
                    }
                });
            }
        },
        isDropdownDisabled(index, member) {
            if (index === 0) return false;
            return !member.reportsToId;
        },
        async handleGenerateResponse(promptText) {
            if (!promptText || !promptText.trim()) return;
            const aiPrompt = `Write a clear, detailed, and professional response of 2-3 lines to the following: "${promptText}". Provide a single, continuous paragraph that directly addresses the topic. The response should be suitable for inclusion in a professional proposal, demonstrating technical understanding, accountability, and attention to quality. Maintain a factual and objective tone, avoiding headings, bullet points, numbered lists, marketing language, generic statements, or exaggerated claims. Focus on clarity, precision, and professionalism.`;
            try {
                const response = await this.$store.dispatch("generateAIResponse", aiPrompt);
                if (response) {
                    this.proposal.orgChart.about.description = response;
                }
            } catch (error) {
                console.error("Failed to generate response:", error);
            }
        },
        async generateTeamMemberDescriptions() {
            if (this.isGeneratingMembers) return;
            this.isGeneratingMembers = true;

            try {
                for (const member of this.proposal.orgChart.members) {
                    if (!member.whyTeamMember) {
                        const id = member.teamMemberId;
                        const type = "member";
                        const promptText = `Write a concise introduction highlighting his role in organization. The candidate’s name is ${member.teamMemberName} and his role is ${member.role}. In 1–2 professional sentences (maximum 450 characters), explain his primary responsibilities, Maintain a factual, objective tone similar to a job description or professional summary. Avoid marketing language, buzzwords, first-person phrasing, headings, or exaggerated claims.`;

                        const response = await this.$store.dispatch("generateAIResponseById", { type, id, prompt: promptText });
                        if (response) {
                            member.whyTeamMember = response;
                        } else {
                            this.memberErrorMessage = "AI response failed. Please try again.";
                            setTimeout(() => {
                                this.memberErrorMessage = "";
                            }, 3000);
                        }
                    }
                }
            } catch (error) {
                console.error("Batch generation for members failed:", error);
                this.memberErrorMessage = "AI response failed. Please try again.";
                setTimeout(() => {
                    this.memberErrorMessage = "";
                }, 3000);
            } finally {
                this.isGeneratingMembers = false;
            }
        }
    }
};
</script>


<template>
  <div class="d-flex flex-column w-100 bg-white rounded-lg text-left">
    <div class="d-flex flex-column">
      <h4 class="mb-3 font-weight-bold">Organizational Chart</h4>
      <div class="row">
        <div class="col-12 mb-3">
          <SelectDropdown label="Template" :modelValue="proposal.orgChart.template"
            :options="TemplateList.filter(item => item.orientation === proposal.pageOrientation)"
            placeholder="Select Template" @update:modelValue="handleTemplateSelection" :isPreviewable="true" />
        </div>
      </div>

      <div v-if="proposal.orgChart.template" class="row">
        <div class="col-12 col-md-6 mb-3">
          <InputField label="Page Title" :modelValue="proposal.orgChart.title" placeholder="Enter Page Title"
            @update:modelValue="proposal.orgChart.title = $event" />
        </div>
        <div class="col-12 col-md-6 mb-3">
          <div v-if="proposal.orgChart.template === 6 || proposal.orgChart.template === 7">
            <SelectDropdown label="Members" :modelValue="proposal.orgChart.members.map(m => m.teamMemberId)"
              :options="membersOptions" :multi="true" :show-search="true" placeholder="Select Team Members"
              @update:modelValue="handleSimpleMembersSelection" :loading="MembersLoading"
              :canPaginate="canPaginateMembers" @handlePagination="handleMembersPagination"
              :searchQuery.sync="memberSearchQuery" />
          </div>
          <SelectDropdown v-else label="Members" :modelValue="pioneerId" :options="membersOptions" :multi="false"
            :show-search="true" placeholder="Select Team Lead" @update:modelValue="handlePioneerSelection"
            :loading="MembersLoading" :canPaginate="canPaginateMembers" @handlePagination="handleMembersPagination"
            :searchQuery.sync="memberSearchQuery" :disabled="!proposal.orgChart.template" />
        </div>
      </div>

      <div v-if="proposal.orgChart.template && (proposal.orgChart.template == 6 || proposal.orgChart.template == 7)"
        class="row">
        <div class="col-12 col-md-6 mb-3">
          <div v-if="proposal.orgChart.template === 7" class="d-flex flex-column">
            <label class="label mb-3">Projects</label>
            <ProjectsDropdown :modelValue="proposal.orgChart.projects" @update:modelValue="handleProjectSelection"
              :disabled="proposal.orgChart.template !== 7" :multi="proposal.orgChart.template == 3 ? false : true"
              :disable="proposal.orgChart.template !== 7" context="orgChart" />
          </div>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <div v-if="proposal.orgChart.members.length > 0">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <label class="label">Selected Team Members</label>
              <div v-if="proposal.orgChart.template == 6 || proposal.orgChart.template == 7"
                class="d-flex justify-content-end">
                <AppButton variant="primary" size="sm" class="ml-1" @click="generateTeamMemberDescriptions"
                  :disabled="isGeneratingMembers">
                  {{ isGeneratingMembers ? 'Generating...' : 'Generate All' }}
                </AppButton>
              </div>
            </div>
            <InfoCard :list="proposal.orgChart.members" @remove-item="removeTeamMember" @move-item="moveItem"
              idKey="teamMemberId" labelKey="teamMemberName" :isAI="true" :text-limit="450"
              @update="proposal.orgChart.members = [...$event]" context="orgChart" />
            <p class="error-message color-red" v-if="memberErrorMessage">{{ memberErrorMessage }}</p>
          </div>
        </div>
      </div>

      <div
        v-if="proposal.orgChart.template && proposal.orgChart.members.length > 0 && proposal.orgChart.template !== 6 && proposal.orgChart.template !== 7"
        class="row">
        <div class="col-12 col-md-6 mb-3">
          <label class="label">Selected Team Members</label>
          <InfoCard :list="proposal.orgChart.members" @remove-item="removeTeamMember" @move-item="moveItem"
            idKey="teamMemberId" labelKey="teamMemberName" @update="proposal.orgChart.members = [...$event]" />

        </div>
        <div class="col-12 col-md-6 mb-3">
          <label class="label">Surbordinates</label>
          <div v-for="(member, index) in proposal.orgChart.members" :key="member.teamMemberId"
            class="row align-items-center mb-2 no-gutters">
            <SelectDropdown :modelValue="getSubordinates(member.teamMemberId)"
              :options="getAvailableSubordinates(member.teamMemberId)" :multi="true"
              :disabled="isDropdownDisabled(index, member) || proposal.orgChart.template === 6"
              :placeholder="'Select Subordinates for '+ member.teamMemberName" :show-search="true" :loading="MembersLoading"
              :canPaginate="canPaginateMembers" @handlePagination="handleMembersPagination"
              :searchQuery.sync="memberSearchQuery"
              @update:modelValue="s => handleSubordinateSelection(s, member.teamMemberId)" />
          </div>
        </div>
      </div>

      <div
        v-if="proposal.orgChart.template && (proposal.orgChart.template == 3 || proposal.orgChart.template == 4 || proposal.orgChart.template == 5)"
        class="row mb-3">
        <div class="col-12">
          <label class="label">About Section</label>
        </div>
        <div class="col-12 mb-1">
          <div class="row">
            <div :class="`col-12 ${proposal.orgChart.template === 3 ? 'col-md-6' : 'col-md-12'} mb-1`">
              <InputField :modelValue="proposal.orgChart.about.title" placeholder="Enter Title"
                @update:modelValue="proposal.orgChart.about.title = $event"
                :disabled="$store.state.loading.aiGenerate || !proposal.orgChart.template || (proposal.orgChart.template !== 3 && proposal.orgChart.template !== 4 && proposal.orgChart.template !== 5)" />
            </div>
            <div v-if="proposal.orgChart.template === 3" class="col-12 col-md-6 mb-1">
              <ProjectsDropdown :modelValue="proposal.orgChart.projects" @update:modelValue="handleProjectSelection"
                :disabled="proposal.orgChart.template !== 3" :multi="false" :disable="proposal.orgChart.template !== 3"
                context="orgChart" />
            </div>
          </div>
          <div class="d-flex align-items-center">
            <InputField :modelValue="prompt" placeholder="Enter Prompt" @update:modelValue="prompt = $event"
              :disabled="$store.state.loading.aiGenerate || !proposal.orgChart.template || (proposal.orgChart.template !== 3 && proposal.orgChart.template !== 4 && proposal.orgChart.template !== 5)" />
            <AppButton
              :disabled="$store.state.loading.aiGenerate || !prompt.trim() || !proposal.orgChart.template || (proposal.orgChart.template !== 3 && proposal.orgChart.template !== 4 && proposal.orgChart.template !== 5)"
              @click="handleGenerateResponse(prompt)" variant="primary" size="sm" class="ml-1">
              {{ $store.state.loading.aiGenerate ? 'Generating' : 'Generate' }}
            </AppButton>
          </div>
        </div>
        <div class="col-12">
          <InputField :isTextarea="true" :modelValue="proposal.orgChart.about.description"
            placeholder="Generate Response..." @update:modelValue="proposal.orgChart.about.description = $event"
            :disabled="$store.state.loading.aiGenerate || !proposal.orgChart.template || (proposal.orgChart.template !== 3 && proposal.orgChart.template !== 4 && proposal.orgChart.template !== 5)" />
        </div>
      </div>

      <div class="row" v-if="proposal.orgChart.template && proposal.orgChart.style">
        <div v-for="item in [
          { key: 'colorScheme', label: 'Color Scheme' },
          { key: 'heading', label: 'Heading Color', disabled: !proposal.orgChart.template || (proposal.orgChart.template !== 3 && proposal.orgChart.template !== 4 && proposal.orgChart.template !== 5 && proposal.orgChart.template !== 6 && proposal.orgChart.template !== 7) },
          { key: 'label', label: 'Label Color' },
          { key: 'text', label: 'Text Color' }
        ]" :key="item.key" class="col-12 col-md-6 col-lg-3 mb-3">
          <ColorSchemeBox v-if="item.key === 'colorScheme'" :styling="proposal.orgChart.style[item.key]"
            :label="item.label" />
          <StyleBox v-else :styling="proposal.orgChart.style[item.key]" :label="item.label" :disabled="item.disabled" />
        </div>
      </div>
    </div>

    <PreviewTemplates :isPreviewable="isPreviewable" :emptyMessage="previewText">
      <OrgChartTemp1 v-if="proposal.orgChart.template === 1" :orgChart="proposal.orgChart" />
      <OrgChartTemp2 v-if="proposal.orgChart.template === 2" :orgChart="proposal.orgChart" />
      <OrgChartTemp3 v-if="proposal.orgChart.template === 3" :orgChart="proposal.orgChart" />
      <OrgChartTemp4 v-if="proposal.orgChart.template === 4" :orgChart="proposal.orgChart" />
      <OrgChartTemp5 v-if="proposal.orgChart.template === 5" :orgChart="proposal.orgChart" />
      <OrgChartTemp6 v-if="proposal.orgChart.template === 6" :orgChart="proposal.orgChart" />
      <OrgChartTemp7 v-if="proposal.orgChart.template === 7" :orgChart="proposal.orgChart" />
    </PreviewTemplates>
  </div>
</template>

<style scoped lang="scss">
.label {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 4px;
}
</style>
